import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import aiBubbleAnimation from '../assets/lottie/ai-bubble.json'; // Adjust path as needed
import styled, { keyframes } from 'styled-components';

const fadeInButton = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const IntroAnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: top;
//   height: 100vh;
  text-align: center;
  background-color: #F8F8FF;
  overflow: hidden;
  width: 100%;
`;

export const LottieAnimationWrapper = styled.div`
  margin-bottom: 20px;
`;

export const StepsText = styled.div`
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  font-size: 1.5em;
  color: #333;
  position: relative;
  width: 90%; /* Adjust width for text container */
  max-width: 600px; /* Max width for larger screens */
`;

export const StepItem = styled.p`
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.5s ease-out, transform 0.5s ease-out;
  position: absolute;
  width: 100%;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  font-weight: 600;

  &.active {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
`;

export const StartButton = styled.button`
  padding: 12px 25px;
  font-size: 1.1em;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  opacity: 0;
  transform: translateY(20px);
  animation: ${fadeInButton} 0.8s ease-out forwards;
  animation-delay: 2s;

  &:hover {
    background-color: #0056b3;
  }
`;

const IntroAnimation = ({ onStart }) => {
    const steps = [
      "¡Hola!",
      "Vamos a medir tus signos vitales.",
      "Para comenzar, sigue estos pasos:",
      "1. Permite acceso a tu cámara.",
      "2. Rellena los datos solicitados.",
      "3. Colócate frente a la cámara, retira los accesorios faciales y manten una posición estable."
    ];
  
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    // const [showButton, setShowButton] = useState(false);
    const [hasCompletedFirstCycle, setHasCompletedFirstCycle] = useState(false); // New state to track first loop
  
    useEffect(() => {
      let timer;
  
      if (currentStepIndex < steps.length) {
        // Continue showing next step
        timer = setTimeout(() => {
          setCurrentStepIndex(prevIndex => prevIndex + 1);
        }, 4000); 
      } else {
        // All steps displayed in the current cycle
        if (!hasCompletedFirstCycle) {
          // After the first cycle, show the button
        //   setShowButton(true);
          setHasCompletedFirstCycle(true);
        }
        // Reset to 0 to start the loop again after a short delay
        timer = setTimeout(() => {
          setCurrentStepIndex(0); // Loop back to the first step
        }, 4000); 
      }
  
      return () => clearTimeout(timer); // Cleanup the timer
    }, [currentStepIndex, steps.length, hasCompletedFirstCycle]); // Add hasCompletedFirstCycle to dependencies
  
    const handleStartClick = () => {
      onStart();
    };
  
    return (
      <IntroAnimationContainer>
        <LottieAnimationWrapper>
          <Lottie
            animationData={aiBubbleAnimation}
            loop={true}
            autoplay={true}
            style={{ width: '35vh', height: '35vh' }}
          />
        </LottieAnimationWrapper>
  
        <StepsText>
          {steps.map((step, index) => (
            <StepItem
              key={index}
              className={index === currentStepIndex - 1 ? 'active' : ''}
            >
              {step}
            </StepItem>
          ))}
        </StepsText>
  
        {/* The button only shows after the first full cycle */}
       
          {/* <StartButton className="fade-in" onClick={handleStartClick}>
            Comenzar
          </StartButton> */}

      </IntroAnimationContainer>
    );
  };
  
  export default IntroAnimation;